/**
 * Replaces the product-highlight marker in the article body with the upsale section.
 * Add <we-site-product-highlight></we-site-product-highlight> in the article HTML.
 */
(() => {
  const root = document.querySelector('.we-site-blog-upsale[data-upsale-pending]');
  if (!(root instanceof HTMLElement)) return;

  const content = document.querySelector('.article__content');
  if (!(content instanceof HTMLElement)) {
    root.removeAttribute('data-upsale-pending');
    return;
  }

  const section =
    root.closest('.we-site-blog-upsale-section') ||
    root.closest('[id^="shopify-section-"]') ||
    root;

  const marker = content.querySelector('we-site-product-highlight');

  if (marker) {
    marker.replaceWith(section);
  }

  root.removeAttribute('data-upsale-pending');
})();
